import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ModalModel } from '@libs/common/models';
import { IconComponent } from '@libs/components/icons';
import { BypassSecurityPipe } from '@libs/shared/ui';
import { ButtonComponent } from '../../../actions/button';

@Component({
  selector: 'ui-modal-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './modal-panel.component.html',
  styleUrls: ['./modal-panel.component.scss'],
  imports: [
    MatDialogModule,
    BypassSecurityPipe,
    IconComponent,
    ButtonComponent,
  ],
})
export class ModalPanelComponent {
  public readonly data: ModalModel = inject<ModalModel>(MAT_DIALOG_DATA);
}
